<em-card [padding]="false">
  <em-products-list
    [groupId]="groupId()"
    (groupIdChange)="groupChanged($event)"
    (filterClear)="clearFilters()"
  ></em-products-list>
</em-card>
